
var HEART_W = 422.043, HEART_H = 363.7065;
var HEART_TOP_Y = -181.8532, HEART_BOTTOM_Y = 181.8532, HEART_CLEFT_Y = -142.0291;
var HEART_PTS_FLAT = [-0.13,181.85,-47.2,145.39,-105.16,102.66,-127.94,84.6,-143.67,70.97,-157.69,57.63,-169.9,44.54,-180.3,31.67,-191.13,15.54,-199.3,0.15,-205.05,-14.46,-209.11,-30.38,-210.85,-44.96,-210.62,-60.84,-208.21,-76.69,-203.67,-92.51,-197.04,-108.28,-188.67,-123.41,-178.98,-136.92,-168.85,-147.96,-156.38,-158.49,-143.63,-166.7,-129.6,-173.46,-114.92,-178.33,-99.91,-181.1,-83.42,-181.8,-68.43,-180.35,-52.46,-176.55,-37.15,-170.5,-23.94,-163.02,-11.72,-153.75,0.22,-142.17,13.27,-154.76,26.58,-164.46,41.61,-172.31,49.48,-175.39,58.8,-178.21,74.97,-181.16,92.56,-181.7,108.62,-179.8,125.56,-175.2,136.87,-170.5,147.74,-164.58,158.06,-157.45,166.7,-150.13,175.74,-140.79,183.78,-130.68,191.52,-119.08,198.04,-107.02,203.3,-94.47,206.9,-82.74,209.4,-70.6,210.77,-58.03,210.96,-46.55,209.87,-33.99,207.8,-23.21,204.32,-11.48,200.84,-2.63,196.1,7.22,190.61,16.8,183.64,27.28,167.97,46.92,149.68,65.75,133.17,80.46,114.85,95.24,37.17,153.21,1.17,181.33,-0.13,181.85];

function heartPts(scale){
  var out=[], a=HEART_PTS_FLAT;
  for(var i=0;i<a.length;i+=2) out.push([a[i]*scale, a[i+1]*scale]);
  return out;
}
function heartPathD(scale, prec){
  if(prec===undefined) prec=3;
  var pts=heartPts(scale);
  var d='M'+pts[0][0].toFixed(prec)+' '+pts[0][1].toFixed(prec);
  for(var i=1;i<pts.length;i++) d+=' L'+pts[i][0].toFixed(prec)+' '+pts[i][1].toFixed(prec);
  return d+' Z';
}
function heartClipperPath(scale, CSCALE){
  var pts=heartPts(scale);
  return pts.map(function(p){return {X:Math.round(p[0]*CSCALE), Y:Math.round(p[1]*CSCALE)};});
}
// CSS clip-path: path('...') string for an element of pixel width pxW
// (height follows the heart's aspect ratio automatically), origin top-left.
function heartClipPathCSS(pxW, prec){
  if(prec===undefined) prec=1;
  var scale=pxW/HEART_W, pts=heartPts(scale);
  var halfW=pxW/2, halfH=(HEART_H*scale)/2;
  var d='M'+(pts[0][0]+halfW).toFixed(prec)+' '+(pts[0][1]+halfH).toFixed(prec);
  for(var i=1;i<pts.length;i++) d+=' L'+(pts[i][0]+halfW).toFixed(prec)+' '+(pts[i][1]+halfH).toFixed(prec);
  return "path('"+d+" Z')";
}
function pointInHeart(px,py,scale){
  var pts=heartPts(scale), inside=false;
  for(var i=0,j=pts.length-1;i<pts.length;j=i++){
    var xi=pts[i][0],yi=pts[i][1],xj=pts[j][0],yj=pts[j][1];
    if(((yi>py)!==(yj>py)) && (px<(xj-xi)*(py-yi)/(yj-yi)+xi)) inside=!inside;
  }
  return inside;
}
function pathsToD(paths, CSCALE, prec){
  if(prec===undefined) prec=3;
  return paths.map(function(poly){
    if(!poly||!poly.length) return '';
    var d='M'+(poly[0].X/CSCALE).toFixed(prec)+' '+(poly[0].Y/CSCALE).toFixed(prec);
    for(var i=1;i<poly.length;i++) d+=' L'+(poly[i].X/CSCALE).toFixed(prec)+' '+(poly[i].Y/CSCALE).toFixed(prec);
    return d+' Z';
  }).filter(Boolean).join(' ');
}
function computeHeartGeometry(W, CSCALE){
  // W = total heart WIDTH in whatever linear unit the caller wants back (px for
  // preview, mm for export). Everything else is derived proportionally.
  var S = W/HEART_W;
  var hR = (HEART_H*S)/2; // half-height -- the heart's analogue of the circle's "radius" for all relative placement math below
  var heartOuter = [heartClipperPath(S, CSCALE)];

  var ringThickness = hR*(17/150);
  var co = new ClipperLib.ClipperOffset(2, 0.05*CSCALE);
  co.AddPaths(heartOuter, ClipperLib.JoinType.jtRound, ClipperLib.EndType.etClosedPolygon);
  var heartInner = new ClipperLib.Paths();
  co.Execute(heartInner, -ringThickness*CSCALE);

  var cR = new ClipperLib.Clipper();
  cR.AddPaths(heartOuter, ClipperLib.PolyType.ptSubject, true);
  cR.AddPaths(heartInner, ClipperLib.PolyType.ptClip, true);
  var ring = new ClipperLib.Paths();
  cR.Execute(ClipperLib.ClipType.ctDifference, ring, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);

  var chY = hR*0.32523547797034436; // chord: text/solid area starts this far below center
                                      // (raised from the original 61/150 by the equivalent of
                                      // 20px at the live-preview's 570px-wide scale, so the
                                      // lower text panel reads ~20px taller there -- and scales
                                      // proportionally at whatever width gets exported)
  var BIG = 1e7;
  var rectBelow = [[{X:-BIG*CSCALE,Y:chY*CSCALE},{X:BIG*CSCALE,Y:chY*CSCALE},{X:BIG*CSCALE,Y:BIG*CSCALE},{X:-BIG*CSCALE,Y:BIG*CSCALE}]];
  var cF = new ClipperLib.Clipper();
  cF.AddPaths(heartInner, ClipperLib.PolyType.ptSubject, true);
  cF.AddPaths(rectBelow, ClipperLib.PolyType.ptClip, true);
  var lowerFill = new ClipperLib.Paths();
  cF.Execute(ClipperLib.ClipType.ctIntersection, lowerFill, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);

  var cM = new ClipperLib.Clipper();
  cM.AddPaths(ring, ClipperLib.PolyType.ptSubject, true);
  cM.AddPaths(lowerFill, ClipperLib.PolyType.ptClip, true);
  var merged = new ClipperLib.Paths();
  cM.Execute(ClipperLib.ClipType.ctUnion, merged, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);

  // Score-line span: scan heartInner's edges for crossings at y=chY so the
  // printed score line exactly matches the merged piece's internal seam,
  // however the heart's curvature happens to fall at that height.
  var xs=[];
  heartInner.forEach(function(poly){
    for(var i=0;i<poly.length;i++){
      var p1=poly[i], p2=poly[(i+1)%poly.length];
      var y1=p1.Y/CSCALE, y2=p2.Y/CSCALE;
      if((y1<=chY&&y2>=chY)||(y2<=chY&&y1>=chY)){
        if(y1===y2) continue;
        var t=(chY-y1)/(y2-y1);
        xs.push((p1.X/CSCALE)+t*((p2.X/CSCALE)-(p1.X/CSCALE)));
      }
    }
  });
  var scoreX1 = xs.length?Math.min.apply(null,xs):0, scoreX2 = xs.length?Math.max.apply(null,xs):0;

  var cleftYmm = HEART_CLEFT_Y*S;
  var hoopO = hR*(19/150), hoopI = hR*(11/150);
  // Hoop sits centered over the heart's natural top notch. Its bottom edge is
  // pulled down to overlap 35% of its own radius INTO the notch so Layer 1's
  // hoop+heart union fuses into one connected cut piece (no floating loop).
  var hoopY = cleftYmm - hoopO*0.65;

  var ty1=76*hR/150, ty2=ty1+25*hR/150, ty3=ty2+22*hR/150; // base text baselines (same proportions the circle generator used, relative to hR instead of rMm)
  var lineShift = hR*0.08143118869632231; // equivalent of 20px at the live-preview's 570px-wide scale; reused below to raise each line's default baseline independently of the others (and scales proportionally at export size)
  var ty1Up=ty1-lineShift; // line 1 only -- ty2/ty3 below still chain off the ORIGINAL (unshifted) ty1 anchor, so this alone doesn't move them

  return {
    S:S, hR:hR, heartOuter:heartOuter, heartInner:heartInner, ring:ring,
    lowerFill:lowerFill, merged:merged, chY:chY, scoreX1:scoreX1, scoreX2:scoreX2,
    hoopY:hoopY, hoopO:hoopO, hoopI:hoopI, cleftYmm:cleftYmm,
    ty1:ty1, ty1Up:ty1Up, ty2:ty2, ty3:ty3, lineShift:lineShift
  };
}
function circlePoly(cx,cy,r,n,CSCALE){
  var p=[];
  for(var i=0;i<n;i++){var a=2*Math.PI*i/n;p.push({X:Math.round((cx+r*Math.cos(a))*CSCALE),Y:Math.round((cy+r*Math.sin(a))*CSCALE)});}
  return p;
}
function hoopRingPaths(geo, CSCALE){
  var hoopOuter=[circlePoly(0,geo.hoopY,geo.hoopO,48,CSCALE)], hoopInner=[circlePoly(0,geo.hoopY,geo.hoopI,36,CSCALE)];
  var cH=new ClipperLib.Clipper();
  cH.AddPaths(hoopOuter,ClipperLib.PolyType.ptSubject,true);
  cH.AddPaths(hoopInner,ClipperLib.PolyType.ptClip,true);
  var hoopRing=new ClipperLib.Paths();
  cH.Execute(ClipperLib.ClipType.ctDifference,hoopRing,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  return hoopRing;
}
function layer1CutPaths(geo, CSCALE){
  var hoopRing = hoopRingPaths(geo, CSCALE);
  var cL=new ClipperLib.Clipper();
  cL.AddPaths(geo.heartOuter,ClipperLib.PolyType.ptSubject,true);
  cL.AddPaths(hoopRing,ClipperLib.PolyType.ptClip,true);
  var l1Cut=new ClipperLib.Paths();
  cL.Execute(ClipperLib.ClipType.ctUnion,l1Cut,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  return l1Cut;
}



(function(){
"use strict";

// ── STATE ────────────────────────────────────────────────────────────────────
var zoom=14, size=4, sizeMin=2, sizeMax=12, detail='med';
var arcSz=[0,14,35,14];
var mapLoaded=false, isLoading=false;
var map=null, pinMarker=null;
var mapCenter=null, mapLabel='';
var zoomValEl=document.getElementById('zoomVal')||{textContent:''};
var PV_W=570;
var PV_GEO=null;
var GAP_MM=8;

// ── HELPERS ──────────────────────────────────────────────────────────────────
function setStatus(cls,msg){var e=document.getElementById('mapStatus');e.className='map-status'+(cls?' '+cls:'');e.textContent=msg;}
function getUnit(){var e=document.querySelector('[data-group="unit"].on');return e?e.dataset.val:'in';}
function fmtZoom(z){return Number.isInteger(z)?String(z):z.toFixed(1);}
function updateDimHint(){
  var u=getUnit(),dh=document.getElementById('dimHint');
  var wMm=(u==='in')?size*25.4:size, hMm=wMm*HEART_H/HEART_W;
  if(dh){
    if(u==='in') dh.textContent='Heart \u2248 '+size.toFixed(2).replace(/\.?0+$/,'')+' \u00d7 '+(hMm/25.4).toFixed(2).replace(/\.?0+$/,'')+' in when cut';
    else dh.textContent='Heart \u2248 '+size.toFixed(0)+' \u00d7 '+hMm.toFixed(0)+' mm when cut';
  }
  var sv=document.getElementById('sizeVal');
  if(sv){if(sv.tagName==='INPUT')sv.value=size;else sv.textContent=size;}
}
function xmlEsc(s){return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}

// ── ROAD WEIGHT TABLE (OpenMapTiles class names) ─────────────────────────────
var WEIGHTS={motorway:7,trunk:5.5,primary:4.5,secondary:3,tertiary:2,
             minor:1.4,service:0.8,track:0.6,path:0.5};
var LOW_CLS =['motorway','trunk','primary','secondary','tertiary'];
var MED_CLS =LOW_CLS.concat(['minor']);
var HIGH_CLS=MED_CLS.concat(['service','track']);
function getAllowedCls(){return detail==='low'?LOW_CLS:detail==='med'?MED_CLS:HIGH_CLS;}

// ── MAPLIBRE CUSTOM STYLE ────────────────────────────────────────────────────
// Minimal ornament-preview style: tan wood background, blue water, black roads.
// No labels, no POIs, no buildings — exactly what the laser-cut piece will show.
// Each road class gets its own layer so MapLibre can apply a simple
// zoom-only interpolation for line-width (nested match+interpolate is illegal).
var ORNAMENT_STYLE={
  version:8,
  name:'Ornament',
  sources:{
    openmaptiles:{
      type:'vector',
      url:'https://tiles.openfreemap.org/planet'
    }
  },
  glyphs:'https://tiles.openfreemap.org/fonts/{fontstack}/{range}.pbf',
  layers:[
    {id:'bg',type:'background',paint:{'background-color':'#d4c3a7'}},
    {id:'water',type:'fill',source:'openmaptiles','source-layer':'water',
     paint:{'fill-color':'#7ec8e3','fill-opacity':0.9}},
    {id:'waterway',type:'line',source:'openmaptiles','source-layer':'waterway',
     paint:{'line-color':'#7ec8e3','line-width':['interpolate',['linear'],['zoom'],8,0.5,14,3,18,6],'line-opacity':0.85},
     layout:{'line-cap':'round','line-join':'round'}},
    {id:'road-motorway',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['match',['get','class'],['motorway','trunk'],true,false],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],6,0.4,10,1.8,14,5,18,10]},
     layout:{'line-cap':'round','line-join':'round'},minzoom:5},
    {id:'road-primary',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['match',['get','class'],['primary','secondary'],true,false],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],8,0.2,10,1,14,3,18,6]},
     layout:{'line-cap':'round','line-join':'round'},minzoom:7},
    {id:'road-tertiary',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['==',['get','class'],'tertiary'],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],10,0.2,12,0.8,14,1.8,18,4]},
     layout:{'line-cap':'round','line-join':'round'},minzoom:9},
    {id:'road-med',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['==',['get','class'],'minor'],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],12,0.3,14,1.2,18,3]},
     layout:{'line-cap':'round','line-join':'round','visibility':'visible'},minzoom:11},
    {id:'road-high',type:'line',source:'openmaptiles','source-layer':'transportation',
     filter:['match',['get','class'],['service','track'],true,false],
     paint:{'line-color':'#000','line-width':['interpolate',['linear'],['zoom'],14,0.4,18,1.5]},
     layout:{'line-cap':'round','line-join':'round','visibility':'none'},minzoom:13}
  ]
};

// The layers used for queryRenderedFeatures at export time
var ROAD_LAYERS_ALL=['road-motorway','road-primary','road-tertiary','road-med','road-high'];

// ── MAPLIBRE INIT ────────────────────────────────────────────────────────────
function initMap(){
  if(map) return;
  map=new maplibregl.Map({
    container:'mapContainer',
    style:ORNAMENT_STYLE,
    center:[0,20],
    zoom:2,
    attributionControl:true,
    dragRotate:false,
    pitchWithRotate:false,
    touchPitch:false
  });
  map.addControl(new maplibregl.AttributionControl({compact:true}),'bottom-right');
  map.on('zoomend',function(){
    zoom=Math.round(map.getZoom()*2)/2;
    zoom=Math.max(7,Math.min(19,zoom));
    document.getElementById('zoomSlider').value=zoom;
    zoomValEl.textContent=fmtZoom(zoom);
  });
}

// ── DETAIL TOGGLE → MAPLIBRE LAYER VISIBILITY ────────────────────────────────
function applyDetailVisibility(){
  if(!map||!map.isStyleLoaded()) return;
  try{
    // Low: only motorway/primary/tertiary. Med: + minor. High: + service/track.
    map.setLayoutProperty('road-med','visibility',detail==='low'?'none':'visible');
    map.setLayoutProperty('road-high','visibility',detail==='high'?'visible':'none');
  }catch(e){}
}

// ── PIN MARKER ───────────────────────────────────────────────────────────────
function buildPinSvg(type){
  var paths={
    heart:'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
    pin:'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
    house:'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
  };
  var d=paths[type]||paths.heart;
  var el=document.createElement('div');
  el.innerHTML='<svg viewBox="0 0 24 24" width="48" height="48" style="filter:drop-shadow(0 2px 3px rgba(0,0,0,0.35))"><path fill="#cc2200" d="'+d+'"/></svg>';
  el.style.cursor='pointer';
  return el;
}

function setPin(lng,lat,type){
  if(pinMarker) pinMarker.remove();
  var el=buildPinSvg(type||'heart');
  pinMarker=new maplibregl.Marker({element:el,anchor:'bottom'}).setLngLat([lng,lat]).addTo(map);
}

// ── GEOCODE & LOAD MAP ───────────────────────────────────────────────────────
async function loadMap(){
  var addr=document.getElementById('addressInput').value.trim();
  if(!addr||isLoading) return;
  isLoading=true;
  var btn=document.getElementById('fetchBtn');
  btn.disabled=true;btn.textContent='Loading\u2026';
  setStatus('','Geocoding\u2026');
  try{
    var cleanAddr=addr.replace(/\s*#\s*\d+[A-Za-z]*/g,'').replace(/\s*\b(Suite|Ste|Apt|Unit|Fl|Floor)\s*\.?\s*\d+[A-Za-z]*/gi,'').replace(/\s{2,}/g,' ').trim();
    var res=await fetch('https://nominatim.openstreetmap.org/search?format=geojson&limit=1&q='+encodeURIComponent(cleanAddr),{headers:{'Accept-Language':'en'}});
    if(!res.ok) throw new Error('Geocoding failed ('+res.status+')');
    var data=await res.json();
    if(!data.features||!data.features.length){setStatus('err','Address not found \u2014 try adding a city or country.');return;}
    var cLon=data.features[0].geometry.coordinates[0];
    var cLat=data.features[0].geometry.coordinates[1];
    mapLabel=((data.features[0].properties&&data.features[0].properties.display_name)||addr).split(',').slice(0,2).join(',');
    mapCenter={lat:cLat,lon:cLon};
    map.flyTo({center:[cLon,cLat],zoom:zoom,duration:1200});
    var pinType=(document.querySelector('.pin-btn.on')||{dataset:{pin:'heart'}}).dataset.pin;
    setPin(cLon,cLat,pinType);
    document.getElementById('noMapPlaceholder').style.display='none';
    mapLoaded=true;
    document.getElementById('downloadBtn').disabled=false;
    setStatus('ok','\u2713 '+mapLabel);
  }catch(err){
    setStatus('err','Error: '+err.message);
  }finally{
    isLoading=false;btn.disabled=false;btn.textContent='Search & Load Map';
  }
}

// ── FEATURE EXTRACTION FROM VECTOR TILES ─────────────────────────────────────
// This replaces the entire Overpass pipeline. Features are already loaded in
// memory by MapLibre's tile decoder — no network request at extract time.
function extractFeatures(){
  if(!map) return {water:[],waterways:[],roads:[]};
  var allowed=getAllowedCls();

  // queryRenderedFeatures returns features currently visible on screen.
  // Geometries are in [lng,lat] geographic coordinates (NOT pixel coords).
  var waterFeats=map.queryRenderedFeatures({layers:['water']});
  var waterwayFeats=map.queryRenderedFeatures({layers:['waterway']});

  // Build road layer list based on detail level
  var roadLayerIds=['road-motorway','road-primary','road-tertiary'];
  if(detail!=='low') roadLayerIds.push('road-med');
  if(detail==='high') roadLayerIds.push('road-high');
  var roadFeats=map.queryRenderedFeatures({layers:roadLayerIds});

  return {water:waterFeats, waterways:waterwayFeats, roads:roadFeats};
}

// Convert GeoJSON [lng,lat] coordinates to mm relative to map center
function makeProjector(widthMm){
  var ctr=map.getCenter();
  var z=map.getZoom();
  var mapEl=document.getElementById('mapContainer');
  var pxW=(mapEl&&mapEl.offsetWidth>0)?mapEl.offsetWidth:PV_W;
  var sc=widthMm/pxW;
  var cpx=map.project(ctr);
  return function(lng,lat){
    var p=map.project([lng,lat]);
    return {x:(p.x-cpx.x)*sc, y:(p.y-cpx.y)*sc};
  };
}

// ── SVG EXPORT HELPERS (unchanged) ───────────────────────────────────────────
function bezierPts(x0,y0,x1,y1,x2,y2,x3,y3,n){
  var p=[];
  for(var i=0;i<=n;i++){var t=i/n,m=1-t;p.push({x:m*m*m*x0+3*m*m*t*x1+3*m*t*t*x2+t*t*t*x3,y:m*m*m*y0+3*m*m*t*y1+3*m*t*t*y2+t*t*t*y3});}
  return p;
}
function quadPts(x0,y0,x1,y1,x2,y2,n){
  var p=[];
  for(var i=0;i<=n;i++){var t=i/n,m=1-t;p.push({x:m*m*x0+2*m*t*x1+t*t*x2,y:m*m*y0+2*m*t*y1+t*t*y2});}
  return p;
}
function otPathToClipper(otPath,CSCALE){
  var polys=[],cur=null,cx=0,cy=0;
  otPath.commands.forEach(function(cmd){
    if(cmd.type==='M'){if(cur&&cur.length>2)polys.push(cur);cur=[];cx=cmd.x;cy=cmd.y;cur.push({X:Math.round(cx*CSCALE),Y:Math.round(cy*CSCALE)});}
    else if(cmd.type==='L'){cx=cmd.x;cy=cmd.y;if(cur)cur.push({X:Math.round(cx*CSCALE),Y:Math.round(cy*CSCALE)});}
    else if(cmd.type==='C'){var pp=bezierPts(cx,cy,cmd.x1,cmd.y1,cmd.x2,cmd.y2,cmd.x,cmd.y,10);cx=cmd.x;cy=cmd.y;if(cur)for(var i=1;i<pp.length;i++)cur.push({X:Math.round(pp[i].x*CSCALE),Y:Math.round(pp[i].y*CSCALE)});}
    else if(cmd.type==='Q'){var pp=quadPts(cx,cy,cmd.x1,cmd.y1,cmd.x,cmd.y,8);cx=cmd.x;cy=cmd.y;if(cur)for(var i=1;i<pp.length;i++)cur.push({X:Math.round(pp[i].x*CSCALE),Y:Math.round(pp[i].y*CSCALE)});}
    else if(cmd.type==='Z'){if(cur&&cur.length>2)polys.push(cur);cur=null;}
  });
  if(cur&&cur.length>2)polys.push(cur);
  return polys;
}
function clipperUnionToD(paths,CSCALE){
  if(!paths||!paths.length) return '';
  var c=new ClipperLib.Clipper();
  c.AddPaths(paths,ClipperLib.PolyType.ptSubject,true);
  var u=new ClipperLib.Paths();
  c.Execute(ClipperLib.ClipType.ctUnion,u,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  return pathsToD(u,CSCALE);
}
function clipperUnionPaths(paths){
  if(!paths||!paths.length) return new ClipperLib.Paths();
  var c=new ClipperLib.Clipper();
  c.AddPaths(paths,ClipperLib.PolyType.ptSubject,true);
  var u=new ClipperLib.Paths();
  c.Execute(ClipperLib.ClipType.ctUnion,u,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  return u;
}
function clipperIntersect(subjectPaths,clipPaths){
  if(!subjectPaths||!subjectPaths.length) return new ClipperLib.Paths();
  var c=new ClipperLib.Clipper();
  c.AddPaths(subjectPaths,ClipperLib.PolyType.ptSubject,true);
  c.AddPaths(clipPaths,ClipperLib.PolyType.ptClip,true);
  var r=new ClipperLib.Paths();
  c.Execute(ClipperLib.ClipType.ctIntersection,r,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
  return r;
}

// ── SVG EXPORT ───────────────────────────────────────────────────────────────
async function exportSVG(){
  if(!map||!mapLoaded){alert('Load a map first.');return;}
  var btn=document.getElementById('downloadBtn');
  btn.disabled=true;btn.textContent='Preparing\u2026';
  try{
    var CSCALE=1e4;
    var unit=getUnit(),realWidthMm=(unit==='in')?(size*25.4):size;
    var geo=computeHeartGeometry(realWidthMm,CSCALE);
    var hR=geo.hR;

    var proj=makeProjector(realWidthMm);

    // ── EXTRACT FEATURES FROM LOADED VECTOR TILES (instant, no network) ──
    btn.textContent='Extracting features\u2026';
    var feats=extractFeatures();
    var allowed=getAllowedCls();

    // ── ROADS ────────────────────────────────────────────────────────────
    btn.textContent='Processing roads\u2026';
    var allRoadPaths=new ClipperLib.Paths();
    feats.roads.forEach(function(feat){
      var cls=feat.properties&&feat.properties.class;
      if(!cls||allowed.indexOf(cls)===-1) return;
      var hw=(WEIGHTS[cls]||1)*(realWidthMm/PV_W)/2;
      var coords=feat.geometry.coordinates;
      if(!coords||!coords.length) return;
      // Handle both LineString and MultiLineString
      var lines=(feat.geometry.type==='MultiLineString')?coords:[coords];
      lines.forEach(function(line){
        if(line.length<2) return;
        var cPath=line.map(function(c){var m=proj(c[0],c[1]);return{X:Math.round(m.x*CSCALE),Y:Math.round(m.y*CSCALE)};});
        var co=new ClipperLib.ClipperOffset(2,0.12*CSCALE);
        co.AddPath(cPath,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etOpenRound);
        var off=new ClipperLib.Paths();co.Execute(off,hw*CSCALE);
        for(var i=0;i<off.length;i++) allRoadPaths.push(off[i]);
      });
    });
    btn.textContent='Merging roads\u2026';
    var roadsUnioned=clipperUnionPaths(allRoadPaths);
    // Clip roads to heart interior above chord (they'll be hidden under Layer 2's solid piece below)
    var BIGR=1e7;
    var rectAbove=[[{X:-BIGR*CSCALE,Y:-BIGR*CSCALE},{X:BIGR*CSCALE,Y:-BIGR*CSCALE},{X:BIGR*CSCALE,Y:geo.chY*CSCALE},{X:-BIGR*CSCALE,Y:geo.chY*CSCALE}]];
    var roadClipRegion=clipperIntersect(geo.heartOuter,rectAbove);
    var roadsFinal=clipperIntersect(roadsUnioned,roadClipRegion);
    var allRoadD=pathsToD(roadsFinal,CSCALE);

    // ── WATER ────────────────────────────────────────────────────────────
    btn.textContent='Processing water\u2026';
    var waterRawPaths=new ClipperLib.Paths();
    var sc=realWidthMm/PV_W;

    // Water polygons (ocean, lakes, wide rivers — already closed in OpenMapTiles)
    feats.water.forEach(function(feat){
      var coords=feat.geometry.coordinates;
      if(!coords) return;
      var rings=(feat.geometry.type==='MultiPolygon')?
        coords.reduce(function(a,p){return a.concat(p);},[]):coords;
      rings.forEach(function(ring){
        if(ring.length<3) return;
        waterRawPaths.push(ring.map(function(c){var m=proj(c[0],c[1]);return{X:Math.round(m.x*CSCALE),Y:Math.round(m.y*CSCALE)};}));
      });
    });

    // Waterway lines (rivers, streams, canals — buffer to filled polygons)
    feats.waterways.forEach(function(feat){
      var coords=feat.geometry.coordinates;
      if(!coords||coords.length<2) return;
      var lines=(feat.geometry.type==='MultiLineString')?coords:[coords];
      lines.forEach(function(line){
        if(line.length<2) return;
        var cPath=line.map(function(c){var m=proj(c[0],c[1]);return{X:Math.round(m.x*CSCALE),Y:Math.round(m.y*CSCALE)};});
        var co=new ClipperLib.ClipperOffset(2,0.12*CSCALE);
        co.AddPath(cPath,ClipperLib.JoinType.jtRound,ClipperLib.EndType.etOpenRound);
        var off=new ClipperLib.Paths();co.Execute(off,2*sc*CSCALE);
        for(var i=0;i<off.length;i++) waterRawPaths.push(off[i]);
      });
    });

    var waterUnioned=clipperUnionPaths(waterRawPaths);
    var waterFinal=clipperIntersect(waterUnioned,geo.heartOuter);
    var waterD=pathsToD(waterFinal,CSCALE);

    // ── TEXT ─────────────────────────────────────────────────────────────
    btn.textContent='Loading fonts\u2026';
    var l1t=(document.getElementById('line1').value||'Where we fell in love').toUpperCase();
    var l2t=document.getElementById('line2').value||"Brittney & Max";
    var l3t=document.getElementById('line3').value||'June 3, 2016';
    var sp12v=parseInt((document.getElementById('sp12')||{value:0}).value)||0;
    var sp23v=parseInt((document.getElementById('sp23')||{value:0}).value)||0;
    var fsc=realWidthMm/PV_W; // mm per preview-pixel — keeps export text the same proportional size as the preview
    var fs1=arcSz[1]*fsc,fs2=arcSz[2]*fsc,fs3=arcSz[3]*fsc;
    var ty1=geo.ty1Up, ty2=geo.ty1+(25+sp12v)*hR/150-geo.lineShift, ty3=ty2+(22+sp23v)*hR/150;
    var ls1=fs1*0.08,ls3=0;
    var l2fDropdown=(document.getElementById('line2Font')||{value:'Great Vibes'}).value;
    var FURL2={
      'Great Vibes':'https://cdn.jsdelivr.net/npm/@fontsource/great-vibes/files/great-vibes-latin-400-normal.woff',
      'Dancing Script':'https://cdn.jsdelivr.net/npm/@fontsource/dancing-script/files/dancing-script-latin-700-normal.woff',
      'Parisienne':'https://cdn.jsdelivr.net/npm/@fontsource/parisienne/files/parisienne-latin-400-normal.woff',
      'Sacramento':'https://cdn.jsdelivr.net/npm/@fontsource/sacramento/files/sacramento-latin-400-normal.woff',
      'Pinyon Script':'https://cdn.jsdelivr.net/npm/@fontsource/pinyon-script/files/pinyon-script-latin-400-normal.woff',
      'Cormorant Garamond':'https://cdn.jsdelivr.net/npm/@fontsource/cormorant-garamond/files/cormorant-garamond-latin-600-normal.woff',
      'Cinzel':'https://cdn.jsdelivr.net/npm/@fontsource/cinzel/files/cinzel-latin-600-normal.woff',
      'Alex Brush':'https://cdn.jsdelivr.net/npm/@fontsource/alex-brush/files/alex-brush-latin-400-normal.woff'
    };
    var f1url='https://cdn.jsdelivr.net/npm/@fontsource/cinzel/files/cinzel-latin-600-normal.woff';
    var f2url=FURL2[l2fDropdown]||FURL2['Great Vibes'];

    function t2pClipper(font,text,cx,cy,sz,ls){
      if(!font||!text.trim()) return '';
      try{
        var opts={letterSpacing:ls||0};
        var pp=font.getPaths(text,0,cy,sz,opts);
        var bx1=Infinity,bx2=-Infinity;
        pp.forEach(function(p){try{var b=p.getBoundingBox();if(isFinite(b.x1)){bx1=Math.min(bx1,b.x1);bx2=Math.max(bx2,b.x2);}}catch(e){}});
        if(!isFinite(bx1)||bx1>=bx2){bx1=0;bx2=font.getAdvanceWidth(text,sz,opts);}
        var startX=cx-(bx1+bx2)/2;
        var otPath=font.getPath(text,startX,cy,sz,opts);
        var polys=otPathToClipper(otPath,CSCALE);
        if(!polys.length) return '';
        return clipperUnionToD(polys,CSCALE);
      }catch(e){console.warn('t2p error:',e);return '';}
    }

    var tp1='',tp2='',tp3='',textAsPath=false;
    if(typeof opentype!=='undefined'){
      var FC={};
      async function lF(u){if(FC[u])return FC[u];var ab=await fetch(u).then(function(r){return r.arrayBuffer();});return(FC[u]=opentype.parse(ab));}
      try{
        btn.textContent='Loading fonts (1/3)\u2026';var font1=await lF(f1url);
        btn.textContent='Loading fonts (2/3)\u2026';var font2=await lF(f2url);
        btn.textContent='Loading fonts (3/3)\u2026';var font3=await lF('https://cdn.jsdelivr.net/npm/@fontsource/cinzel/files/cinzel-latin-600-normal.woff');
        btn.textContent='Merging text glyphs\u2026';
        tp1=t2pClipper(font1,l1t,0,ty1,fs1,ls1);
        tp2=t2pClipper(font2,l2t,0,ty2,fs2,0);
        tp3=t2pClipper(font3,l3t,0,ty3,fs3,ls3);
        textAsPath=!!(tp1||tp2||tp3);
      }catch(fe){console.warn('Font error:',fe);}
    }

    // ── HEART PIN ────────────────────────────────────────────────────────
    var pinPt=mapCenter?proj(mapCenter.lon,mapCenter.lat):{x:0,y:0};
    var pinInHeart=mapCenter&&pointInHeart(pinPt.x,pinPt.y,geo.S);
    var pinVisible=pinInHeart&&pinPt.y<geo.chY;
var pinScale=(hR*0.18)/HEART_W;
var selectedPinType=(document.querySelector('.pin-btn.on')||{dataset:{pin:'heart'}}).dataset.pin;
var PIN_PATHS={
  heart:'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
  pin:'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
  house:'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z'
};

var pinD, pinTransform='';
if(selectedPinType==='heart'){
  pinD=heartPathD(pinScale,3);
}else{
  var iconScale=(hR*0.18)/24;
  pinD=PIN_PATHS[selectedPinType];
  pinTransform=' transform="scale('+iconScale.toFixed(6)+') translate(-12,-12)"';
}

    // ── LAYER 1 CUT ─────────────────────────────────────────────────────
    var l1Cut=layer1CutPaths(geo,CSCALE);
    var l1CutD=pathsToD(l1Cut,CSCALE);

    // ── LAYER 2 (ring + lower text fill) ────────────────────────────────
    var mergedD=pathsToD(geo.merged,CSCALE);

    // ── 3-LAYER MODE: compute land shape (heart minus water) ────────────
    var l3tog=document.getElementById('layer3Toggle');
    var is3Layer=l3tog&&l3tog.checked;
    var landCutD='';
    if(is3Layer&&waterFinal.length){
      var cL3=new ClipperLib.Clipper();
      cL3.AddPaths(geo.heartOuter,ClipperLib.PolyType.ptSubject,true);
      cL3.AddPaths(waterFinal,ClipperLib.PolyType.ptClip,true);
      var landPaths=new ClipperLib.Paths();
      cL3.Execute(ClipperLib.ClipType.ctDifference,landPaths,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      // Support ring = heartOuter - heartInner (so the frame ring always has material behind it)
      var cRing=new ClipperLib.Clipper();
      cRing.AddPaths(geo.heartOuter,ClipperLib.PolyType.ptSubject,true);
      cRing.AddPaths(geo.heartInner,ClipperLib.PolyType.ptClip,true);
      var ringPaths=new ClipperLib.Paths();
      cRing.Execute(ClipperLib.ClipType.ctDifference,ringPaths,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      var cUnion=new ClipperLib.Clipper();
      cUnion.AddPaths(landPaths,ClipperLib.PolyType.ptSubject,true);
      cUnion.AddPaths(ringPaths,ClipperLib.PolyType.ptClip,true);
      var landWithRing=new ClipperLib.Paths();
      cUnion.Execute(ClipperLib.ClipType.ctUnion,landWithRing,ClipperLib.PolyFillType.pftNonZero,ClipperLib.PolyFillType.pftNonZero);
      landCutD=pathsToD(landWithRing,CSCALE);
    }else if(is3Layer){
      landCutD=pathsToD(geo.heartOuter,CSCALE);
    }

    // ── BUILD SVG ────────────────────────────────────────────────────────
    btn.textContent='Building SVG\u2026';
    var hW=HEART_W*geo.S/2;
    var p2x=HEART_W*geo.S+GAP_MM;
    var frameX=is3Layer?(2*(HEART_W*geo.S)+2*GAP_MM):p2x;
    var vbL=-(hW+4), vbT=(geo.hoopY-geo.hoopO)-4, vbR=(is3Layer?frameX:p2x)+hW+4, vbB=hR+28;
    var vbW=vbR-vbL, vbH=vbB-vbT;
    var P=[];
    P.push('<?xml version="1.0" encoding="UTF-8"?>');
    P.push('<!-- Heart Map Ornament | #000000=engrave | #ff0000=cut | #7ec8e3=light engrave (water) -->');
    P.push('<svg xmlns="http://www.w3.org/2000/svg" width="'+vbW.toFixed(2)+'mm" height="'+vbH.toFixed(2)+'mm" viewBox="'+vbL.toFixed(2)+' '+vbT.toFixed(2)+' '+vbW.toFixed(2)+' '+vbH.toFixed(2)+'">');

    if(is3Layer){
      // ── 3-LAYER: L1 = water backing (cut only, no engravings) ─────────
      P.push('<g id="L1-water">');
      P.push('  <text x="0" y="'+(hR+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(hR*0.045).toFixed(2)+'" fill="#888888">Layer 1 (Water): <tspan fill="#ff0000">Red=CUT</tspan></text>');
      if(l1CutD)
        P.push('  <path id="L1-cut" d="'+l1CutD+'" fill="none" stroke="#ff0000" stroke-width="0.1" fill-rule="evenodd"/>');
      P.push('</g>');

      // ── 3-LAYER: L2 = land cutout (heart minus water) + roads ────────
      P.push('<g id="L2-land" transform="translate('+p2x.toFixed(2)+',0)">');
      P.push('  <text x="0" y="'+(hR+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(hR*0.045).toFixed(2)+'" fill="#888888">Layer 2 (Land): <tspan fill="#ff0000">Red=CUT</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#000000">Black=Engrave</tspan></text>');
      if(allRoadD.trim())
        P.push('  <path id="roads" fill="#000000" fill-rule="evenodd" stroke="none" d="'+allRoadD.trim()+'"/>');
      if(landCutD)
        P.push('  <path id="L2-land-cut" d="'+landCutD+'" fill="none" stroke="#ff0000" stroke-width="0.1" fill-rule="evenodd"/>');
      P.push('</g>');

    }else{
      // ── 2-LAYER: L1 = everything (roads + water + cut) ────────────────
      P.push('<g id="L1">');
      P.push('  <text x="0" y="'+(hR+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(hR*0.045).toFixed(2)+'" fill="#888888">Layer 1: <tspan fill="#ff0000">Red=CUT</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#000000">Black=Engrave</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#4a9fc4">Blue=Light engrave (water)</tspan></text>');
      if(allRoadD.trim())
        P.push('  <path id="roads" fill="#000000" fill-rule="evenodd" stroke="none" d="'+allRoadD.trim()+'"/>');
      if(waterD.trim())
        P.push('  <path id="water" fill="#7ec8e3" fill-rule="evenodd" stroke="none" d="'+waterD.trim()+'"/>');
      if(l1CutD)
        P.push('  <path id="L1-cut" d="'+l1CutD+'" fill="none" stroke="#ff0000" stroke-width="0.1" fill-rule="evenodd"/>');
      P.push('</g>');
    }

    { // Frame (ring+arc) — always included, position depends on mode
      P.push('<g id="'+(is3Layer?'L3':'L2')+'" transform="translate('+(is3Layer?frameX:p2x).toFixed(2)+',0)">');
      P.push('  <text x="0" y="'+(hR+8).toFixed(1)+'" text-anchor="middle" font-family="Helvetica Neue,Arial,sans-serif" font-size="'+(hR*0.045).toFixed(2)+'" fill="#888888">'+(is3Layer?'Layer 3':'Layer 2')+': <tspan fill="#ff0000">Red=CUT</tspan><tspan fill="#888888"> \u00b7 </tspan><tspan fill="#000000">Black=Engrave/Score</tspan></text>');
      P.push('  <path id="frame-cut" d="'+mergedD+'" fill="none" stroke="#ff0000" stroke-width="0.1" fill-rule="evenodd"/>');
      P.push('  <line id="score-line" x1="'+geo.scoreX1.toFixed(3)+'" y1="'+geo.chY.toFixed(3)+'" x2="'+geo.scoreX2.toFixed(3)+'" y2="'+geo.chY.toFixed(3)+'" stroke="#000000" stroke-width="0.1"/>');
      if(textAsPath){
        if(tp1) P.push('  <path id="text1" d="'+tp1+'" fill="#000000" fill-rule="evenodd"/>');
        if(tp2) P.push('  <path id="text2" d="'+tp2+'" fill="#000000" fill-rule="evenodd"/>');
        if(tp3) P.push('  <path id="text3" d="'+tp3+'" fill="#000000" fill-rule="evenodd"/>');
      }else{
        P.push('  <!-- Fonts unavailable \u2013 convert text to outlines in Illustrator -->');
        P.push('  <text x="0" y="'+ty1.toFixed(2)+'" text-anchor="middle" font-family="Cinzel,serif" font-size="'+fs1.toFixed(3)+'mm">'+xmlEsc(l1t)+'</text>');
        P.push('  <text x="0" y="'+ty2.toFixed(2)+'" text-anchor="middle" font-family="'+xmlEsc(l2fDropdown)+',cursive" font-size="'+fs2.toFixed(3)+'mm">'+xmlEsc(l2t)+'</text>');
        P.push('  <text x="0" y="'+ty3.toFixed(2)+'" text-anchor="middle" font-family="Cinzel,serif" font-size="'+fs3.toFixed(3)+'mm">'+xmlEsc(l3t)+'</text>');
      }
      P.push('</g>');
    }
    // Heart pin -- standalone in the gap between the first two layers
    if(pinVisible){
      var gapX=hW+GAP_MM/2;
      var gapY=-(hR*0.65);
      P.push('<g id="heart-pin" transform="translate('+gapX.toFixed(3)+','+gapY.toFixed(3)+')">');
      P.push('  <path d="'+pinD+'" fill="#cc2200" stroke="none"'+pinTransform+'/>');
      P.push('</g>');
    }
    P.push('</svg>');

    var svg=P.join('\n');
    var blob=new Blob([svg],{type:'image/svg+xml'});
    var url=URL.createObjectURL(blob);
    var a=document.createElement('a');a.href=url;a.download='heart-map-ornament.svg';a.click();
    setTimeout(function(){URL.revokeObjectURL(url);},1000);
    setStatus('ok','\u2713 '+mapLabel);
  }catch(err){
    console.error('Export error:',err);
    setStatus('err','Export error: '+err.message);
  }finally{
    btn.disabled=false;btn.textContent='\u2193 Download SVG';
  }
}

// ── CONTROLS ─────────────────────────────────────────────────────────────────
document.getElementById('zoomSlider').addEventListener('input',function(){
  zoom=parseFloat(this.value);
  zoomValEl.textContent=fmtZoom(zoom);
  if(map) map.setZoom(zoom);
});
document.getElementById('sizeDown').onclick=function(){
  var el=document.getElementById('sizeVal'),u=getUnit(),step=u==='in'?0.5:5;
  size=Math.max(sizeMin,+(((parseFloat(el.value||el.textContent)||4)-step).toFixed(3)));
  if(el.tagName==='INPUT')el.value=size;else el.textContent=size;updateDimHint();
};
document.getElementById('sizeUp').onclick=function(){
  var el=document.getElementById('sizeVal'),u=getUnit(),step=u==='in'?0.5:5;
  size=Math.min(sizeMax,+(((parseFloat(el.value||el.textContent)||4)+step).toFixed(3)));
  if(el.tagName==='INPUT')el.value=size;else el.textContent=size;updateDimHint();
};
document.getElementById('sizeVal').addEventListener('input',function(){
  var v=parseFloat(this.value);
  if(!isNaN(v)) { size=Math.max(sizeMin,Math.min(sizeMax,v)); updateDimHint(); }
});
document.querySelectorAll('.seg .sb').forEach(function(btn){
  btn.addEventListener('click',function(){
    var g=btn.dataset.group;if(!g)return;
    document.querySelectorAll('.sb[data-group="'+g+'"]').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    if(g==='detail'){
      detail=btn.dataset.val;
      applyDetailVisibility();
    }
  });
});
document.querySelectorAll('[data-group="unit"]').forEach(function(btn){
  btn.addEventListener('click',function(){
    var prevUnit=getUnit();
    document.querySelectorAll('[data-group="unit"]').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    var nextUnit=getUnit();
    if(prevUnit===nextUnit)return;
    var el=document.getElementById('sizeVal');
    var v=parseFloat(el?(el.value||el.textContent):'4')||4;
    if(prevUnit==='in'&&nextUnit==='mm')v=Math.round(v*25.4*10)/10;
    else if(prevUnit==='mm'&&nextUnit==='in')v=Math.round(v/25.4*100)/100;
    size=v;sizeMin=nextUnit==='in'?2:25;sizeMax=nextUnit==='in'?12:300;
    if(el){if(el.tagName==='INPUT')el.value=v;else el.textContent=v;}
    updateDimHint();
  });
});
document.querySelectorAll('.pin-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    document.querySelectorAll('.pin-btn').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    if(pinMarker&&mapCenter) setPin(mapCenter.lon,mapCenter.lat,btn.dataset.pin);
  });
});
document.getElementById('fetchBtn').addEventListener('click',loadMap);
document.getElementById('addressInput').addEventListener('keydown',function(e){if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();loadMap();}});

var SZ_MIN=[0,5,10,5],SZ_MAX=[0,18,60,20],SZ_STEP=[0,0.5,1,0.5];
document.querySelectorAll('.arc-sz-btn').forEach(function(b){
  b.addEventListener('click',function(){
    var line=parseInt(this.dataset.szline),dir=parseInt(this.dataset.dir);
    arcSz[line]=Math.max(SZ_MIN[line],Math.min(SZ_MAX[line],arcSz[line]+SZ_STEP[line]*dir));
    var valEl=document.getElementById('sz'+line+'val');
    if(valEl)valEl.textContent=arcSz[line].toFixed(arcSz[line]%1?1:0);
    updatePreview();
  });
});
var l2f=document.getElementById('line2Font');
if(l2f)l2f.addEventListener('change',updatePreview);
['sp12','sp23'].forEach(function(id){var el=document.getElementById(id);if(el)el.addEventListener('input',updatePreview);});
document.getElementById('downloadBtn').addEventListener('click',exportSVG);

// ── PREVIEW TEXT ──────────────────────────────────────────────────────────────
function updatePreview(){
  if(!PV_GEO) return;
  var l1=document.getElementById('line1').value||'Where we fell in love';
  var l2=document.getElementById('line2').value||"Brittney & Max";
  var l3=document.getElementById('line3').value||'June 3, 2016';
  var f2sel=document.getElementById('line2Font');
  var f2font=f2sel?f2sel.value:'Great Vibes';
  var fs1=arcSz[1],fs2=arcSz[2],fs3=arcSz[3];
  var sp12=parseInt((document.getElementById('sp12')||{value:0}).value)||0;
  var sp23=parseInt((document.getElementById('sp23')||{value:0}).value)||0;
  var ty1=PV_GEO.ty1Up, ty2=PV_GEO.ty1+(25+sp12)*PV_GEO.hR/150-PV_GEO.lineShift, ty3=ty2+(22+sp23)*PV_GEO.hR/150;
  function set(id,txt,font,fs,ty,ls){
    var e=document.getElementById(id);if(!e)return;
    e.textContent=txt;
    if(font)e.setAttribute('font-family',font);
    if(fs)e.setAttribute('font-size',fs);
    if(ty)e.setAttribute('y',ty);
    if(ls!=null)e.setAttribute('letter-spacing',ls);
  }
  set('prevLine1',l1.toUpperCase(),'Cinzel,serif',fs1,ty1,(fs1*0.2).toFixed(1));
  set('prevLine2',l2,f2font+',cursive',fs2,ty2,0);
  set('prevLine3',l3,'Cinzel,serif',fs3,ty3,0);
}
['line1','line2','line3'].forEach(function(id){var e=document.getElementById(id);if(e)e.addEventListener('input',updatePreview);});

// ── RESET ─────────────────────────────────────────────────────────────────────
document.getElementById('resetBtn').addEventListener('click',function(){
  document.getElementById('addressInput').value='';
  setStatus('','No map loaded');
  ['line1','line2','line3'].forEach(function(id){document.getElementById(id).value='';});
  zoom=14;zoomValEl.textContent='14';document.getElementById('zoomSlider').value='14';
  size=4;updateDimHint();detail='med';
  document.querySelectorAll('.pin-btn').forEach(function(b,i){b.classList.toggle('on',i===0);});
  document.querySelectorAll('.sb[data-group="detail"]').forEach(function(b){b.classList.toggle('on',b.dataset.val==='med');});
  var l3t=document.getElementById('layer3Toggle');if(l3t)l3t.checked=false;
  if(pinMarker){pinMarker.remove();pinMarker=null;}
  if(map){map.flyTo({center:[0,20],zoom:2,duration:0});}
  mapCenter=null;mapLoaded=false;
  document.getElementById('noMapPlaceholder').style.display='';
  document.getElementById('downloadBtn').disabled=true;
  applyDetailVisibility();
  updatePreview();
});

// ── INIT ─────────────────────────────────────────────────────────────────────
function buildStaticPreviewGeometry(){
  var CSCALE=1e4;
  PV_GEO=computeHeartGeometry(PV_W,CSCALE);
  var hoopRing=hoopRingPaths(PV_GEO,CSCALE);
  var hoopEl=document.getElementById('hoopIconPath');
  if(hoopEl) hoopEl.setAttribute('d', pathsToD(hoopRing,CSCALE));
  var frameEl=document.getElementById('frameOverlayPath');
  if(frameEl) frameEl.setAttribute('d', pathsToD(PV_GEO.merged,CSCALE));

  // clip the live map to the heart silhouette
  var clip=heartClipPathCSS(PV_W);
  var mapEl=document.getElementById('mapContainer'), phEl=document.getElementById('noMapPlaceholder');
  if(mapEl) mapEl.style.clipPath=clip;
  if(phEl) phEl.style.clipPath=clip;
}

window._appLoadMap=loadMap;
window._appMap=null;
window.onerror=function(msg,src,line,col,err){
  var el=document.getElementById('mapStatus');
  if(el)el.innerHTML='<span style="color:#ff7c7c;font-weight:700">JS Error: '+msg+' (line '+line+')</span>';
  return false;
};
try{
  initMap();
  window._appMap=map;
  buildStaticPreviewGeometry();
  map.on('style.load',function(){applyDetailVisibility();});
}catch(e){
  var el=document.getElementById('mapStatus');
  if(el)el.innerHTML='<span style="color:#ff7c7c;font-weight:700">Init error: '+e.message+'</span>';
}
updateDimHint();
updatePreview();

})();